<template>
    <vue-scroll :settings="{wheelPropagation:true}" v-if="!isMobile" class="games-menu-desktop">
        <div class="games-menu" v-if="expandedMenu">
            <div class="gamesm-form" v-if="!isResultsPage">
                <div class="loading-container" v-if="searchLoading"><img src="../../../assets/img/loading.svg"></div>
                <div class="gamesm-close-search-big" v-on:click.stop="clearSearch()" v-if="showSearchResults"></div>
                <div class="input-box">
                    <input v-on:keyup.enter="startSearch" class="input-text" type="text" :placeholder="$t('SEARCHBYMATCHNAME')" v-model="searchText">
                </div>

                <a class="button button-input"
                @click.stop="startSearch">
                    <i class="iconset icon-search"></i>
                </a>
            </div>
            <div class="gamesm-search-box" v-if="showSearchResults">
                <vue-scroll :settings="{wheelPropagation:true}" class="gamesm-search-container" v-if="!searchError">
                    <div class="gamesm-search-item" v-for="sport in searchResults" :key="sport.sportId">
                             <template v-if="sport.outrights">
                             <div class="gamesm-searchi-header lb-sport sportbordercolor-outrights">{{sport.name}}</div><!-- + sportMapping[outright.outrightsOfferId] -->
                            <div class="gamesm-searchi-content" v-for="outright in sport.outrights" :key="outright.outrightId"
                                    v-on:click.prevent="selectOutright({
                                    outrightId: outright.outrightsOfferId,
                                    eventType: 'sport',
                                    push: null})" >
                                <p class="gamesm-searchi-teams">{{outright.name}}</p>
                                <p class="gamesm-searchi-tour">{{outright.tree[0].name}}</p>
                                <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(outright.endDate)}}</p>
                                <p v-else class="gamesm-searchi-date">{{outright.endDate | getLocalDate}}</p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="gamesm-searchi-header lb-sport" :class="'sportbordercolor-' + sportMapping[sport.sportId]">{{offertree.sports[sport.sportId].sportName}}</div>
                            <div class="gamesm-searchi-content" v-for="match in sport.matches" :key="match.matchId" v-on:click.prevent="selectSearchMatch(match.matchId)">
                                <p class="gamesm-searchi-teams">{{match.teamNameOne || 'not defined'}} - {{match.teamNameTwo || 'not defined'}}</p>
                                <p class="gamesm-searchi-tour">{{offertree.tournaments[match.tournamentId].tournamentName}}</p>
                                <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(match.matchDate)}}</p>
                                <p v-else class="gamesm-searchi-date">{{match.matchDate | getLocalDate}}</p>
                            </div>
                        </template>
                    </div>
                </vue-scroll>
                <div v-if="searchError" class="gamesm-search-container">
                    <div class="gamesm-search-item no-results">{{ $t(searchError) }}</div>
                </div>
            </div>
            <template
            v-if="globals
            && globals.publicConfig
            && globals.publicConfig.website
            && globals.publicConfig.website.displayPromoFilters">
                <div class="soccer gamesm-item-promo">
                    <div class="gamesm-text">Liga prvaka</div>
                </div>
                <div class="basketball gamesm-item-promo">
                    <div class="gamesm-text">FIBA EuroBasket 2022</div>
                </div>
            </template>
            <div class="games-menu-scroll" ref_testcafe="gamesMenu">
                <div class="gamesm-item minimize" @click="expandedMenu = !expandedMenu">
                    <div class="gamesm-item-content game-minimize">
                        <div class="gamesm-content-left">
                            <i class="sportsicon icon-arrowleft"></i>
                            <div class="gamesm-text">{{$t('MINIMIZE')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gamesm-item" v-if="showFavourites && !isResultsPage" :class="{'is-selected': onFavourites}">
                    <div class="gamesm-item-content game-all" @click="toggleFavouriteSportFilter">
                        <div class="gamesm-content-left">
                            <i class="sportsicon lb-sport sporticon-favouritesactive"></i>
                            <div class="gamesm-text">{{$t('FAVOURITES')}} ({{favouritesOnCurrentOffer.length}})</div>
                        </div>
                    </div>
                </div>
                <div v-if="!isResultsPage" class="gamesm-item" :class="{'is-selected': (sportsselected[0] === 'all' && !onFavourites)}">
                    <div class="gamesm-item-content game-all" v-on:click="toggleAllSportsFilter()">
                        <div class="gamesm-content-left">
                            <i class="sportsicon icon-all"></i>
                            <div class="gamesm-text">{{$t('ALLSPORTS')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gamesm-item" v-for="sport in sports" :key="sport.sportId" :class="(sportsselected[0] == sport.sportId) ? 'is-selected' : ''">
                    <div class="gamesm-item-content lb-sport game-border" :class="'sportbordercolor-' + sportMapping[sport.sportId]" v-on:click.stop="selectSport([sport.sportId])">
                        <div class="gamesm-content-left">
                            <i class="sportsicon lb-sport" :class="getSportIconClass(sport.sportId)"></i>
                            <div class="gamesm-text">{{sport.sportName}} ({{sport.matchesNum}})</div>
                            <div v-if="sportState != 'live' && outrightsIn && outrightsIn.sportIds && outrightsIn.sportIds.indexOf(parseInt(sport.sportId)) != -1" class="match-outrights-icon">
                                <img src="../../../assets/img/icon-outrights.svg">
                            </div>
                        </div>
                        <div class="gamesm-content-right" v-on:click.stop="toggleSport(sport.sportId)">
                            <span class="gamesm-arrow" :class="(sportsShown.indexOf(sport.sportId) !== -1) ? 'is-selected' : ''"></span>
                        </div>
                    </div>
                    <div class="gamesm-match-box" v-if="sportState == 'live' && !isResultsPage && sportsShown.indexOf(sport.sportId) !== -1 ">
                        <div class="gamesm-match-box-item" v-on:click.stop="selectMatch(match.matchId)" v-for="match in sport.matches" :key="match.matchId" :class="{'is-blocked': (matchesIn[match.matchId].status == 'block' || (globalEventBlock[sportState] && !isResultsPage))}">
                            <div class="gamesm-subitem-live-box">
                                <div class="gamesm-subitem-live-match">
                                    <div class="ggame-live-stream" v-if="matchesIn[match.matchId].stream && matchesIn[match.matchId].stream !== 'nostream'">
                                         <div class="icon-stream-booked">
                                            <i class="iconset icon-stream"></i>
                                            <div class="pulse" v-if="matchesIn[match.matchId].stream === 'live'"></div>
                                         </div>
                                    </div>
                                    <div class="teams">
                                        <p>{{matchesIn[match.matchId].teamNameOne || 'not defined'}}</p>
                                        <p>{{matchesIn[match.matchId].teamNameTwo || 'not defined'}}</p>
                                    </div>
                                    <div class="time-icons">
                                        <p>{{getLiveMinutes(matchesIn[match.matchId])}}</p>
                                    </div>
                                    <div class="match-score">
                                        <p class="home">{{matchesIn[match.matchId].metaData.t1Scr}}</p>
                                        <p class="away">{{matchesIn[match.matchId].metaData.t2Scr}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="(sportState == 'prematch' || isResultsPage)  && sportsShown.indexOf(sport.sportId) !== -1">
                        <div class="dropdown-scroll fadeInDownMobileFilter">
                            <div class="gamesm-category-box" v-for="category in sport.categories" :key="category.categoryId" :class="(categoryselected[0] == category.categoryId) ? 'is-selected' : ''" :ref_testcafe="(categoryselected[0] == category.categoryId) ? 'selectedCategory' : ''" v-on:click.stop="selectCategory(sport, category)">
                                <div class="gamesm-category-content">
                                    <div class="gamesm-content-left">
                                        <div class="gamesm-text small">{{category.categoryName}} ({{category.matchesNum}})</div>
                                        <div v-if="sportState != 'live' && outrightsIn && outrightsIn.categoryIds && outrightsIn.categoryIds.indexOf(parseInt(category.categoryId)) != -1" class="match-outrights-icon">
                                            <img src="../../../assets/img/icon-outrights.svg">
                                        </div>
                                    </div>
                                    <div class="gamesm-content-right"
                                    v-on:click.stop="toggleCategory(category.categoryId)"
                                    v-if="category.hasTournamentFilter === undefined
                                    || category.hasTournamentFilter === true">
                                        <span class="gamesm-arrow" :class="(categoriesShown.indexOf(category.categoryId) !== -1) ? 'is-selected' : ''"></span>
                                    </div>
                                </div>
                                <template v-if="categoriesShown.indexOf(category.categoryId) !== -1">
                                    <div class="gamesm-tour-box fadeInDownMobileFilter" :key="tournament.tournamentId" v-for="tournament in category.tournaments" :class="(tournamentselected[0] == tournament.tournamentId) ? 'is-selected' : ''" v-on:click.stop="selectTournament(sport, category, tournament)">
                                        <div class="gamesm-tour-content">
                                            <div class="gamesm-content-left">
                                                <div class="gamesm-text small">{{tournament.tournamentName}} ({{tournament.matchesNum}})</div>
                                                <div v-if="sportState != 'live' && outrightsIn && outrightsIn.tournamentIds &&  outrightsIn.tournamentIds.indexOf(parseInt(tournament.tournamentId)) != -1" class="match-outrights-icon">
                                                    <img src="../../../assets/img/icon-outrights.svg">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!--**************** -->
        </div>
        <div class="games-menu-small modalTicketAnimation" v-if="!expandedMenu">
            <div class="gamesm-item search" v-if="!isResultsPage">
                <div class="gamesm-search-icon" @click="showSearchBox">
                    <i class="sportsicon icon-search"></i>
                    <div class="gamesm-close-search" style="display:none">
                        <img class="close-search-icon" src="../../../assets/img/close.svg" alt="close icon">
                        <img class="close-search-icon-light" src="../../../assets/img/close-light.svg" alt="close light icon">
                    </div>
                </div>
            </div>
            <transition name="fade">
                <!-- Small menu search input -->
                <div class="gamesm-search-box 2" v-if="searchBox">
                    <div class="loading-container" v-if="searchLoading"><img src="../../../assets/img/loading.svg"></div>
                    <div class="input-box">
                        <input v-on:keyup.enter="startSearch" :placeholder="$t('SEARCHBYMATCHNAME')" class="input-text" type="text" ref="searchBoxInput" v-model="searchText">
                        <div v-on:click.stop="startSearch" class="search-box-button"><i class="sportsicon icon-search"></i></div>
                    </div>
                    <vue-scroll :settings="{wheelPropagation:true}" class="gamesm-search-container" v-if="showSearchResults && !searchError">
                       <div class="gamesm-search-item" v-for="sport in searchResults" :key="sport.sportId">
                             <template v-if="sport.outrights">
                             <div class="gamesm-searchi-header lb-sport sportbordercolor-outrights">{{sport.name}}</div>
                            <div class="gamesm-searchi-content" v-for="outright in sport.outrights" :key="outright.outrightId"
                                    v-on:click.prevent="selectOutright({
                                    outrightId: outright.outrightsOfferId,
                                    eventType: 'sport',
                                    push: null})" >
                                <p class="gamesm-searchi-teams">{{outright.name}}</p>
                                <p class="gamesm-searchi-tour">{{outright.tree[0].name}}</p>
                                <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(outright.endDate)}}</p>
                                <p v-else class="gamesm-searchi-date">{{outright.endDate | getLocalDate}}</p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="gamesm-searchi-header lb-sport" :class="'sportbordercolor-' + sportMapping[sport.sportId]">{{offertree.sports[sport.sportId].sportName}}</div>
                            <div class="gamesm-searchi-content" v-for="match in sport.matches" :key="match.matchId" v-on:click.prevent="selectSearchMatch(match.matchId)">
                                <p class="gamesm-searchi-teams">{{match.teamNameOne || 'not defined'}} - {{match.teamNameTwo || 'not defined'}}</p>
                                <p class="gamesm-searchi-tour">{{offertree.tournaments[match.tournamentId].tournamentName}}</p>
                                <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(match.matchDate)}}</p>
                                <p v-else class="gamesm-searchi-date">{{match.matchDate | getLocalDate}}</p>
                            </div>
                        </template>
                    </div>
                    </vue-scroll>
                    <div v-if="showSearchResults && searchError" class="gamesm-search-container">
                        <div class="gamesm-search-item no-results">{{ $t(searchError) }}</div>
                    </div>
                </div>
            </transition>

            <template
            v-if="globals
            && globals.publicConfig
            && globals.publicConfig.website
            && globals.publicConfig.website.displayPromoFilters">
                <div class="soccer gamesm-item-promo">
                    <div class="gamesm-text">Liga prvaka</div>
                </div>
                <div class="basketball gamesm-item-promo">
                    <div class="gamesm-text">FIBA EuroBasket 2022</div>
                </div>
            </template>

            <div class="gamesm-item expand" @click="expandedMenu = !expandedMenu">
                <i class="icon-arrow-down"></i>
            </div>

            <div
                class="gamesm-item lb-sport game-border all game-all"
                @click.stop="toggleFavouriteSportFilter" v-if="showFavourites && !isResultsPage"
                :class="{'is-selected': onFavourites}"
            >
                <i class="sportsicon lb-sport sporticon-favouritesactive"></i>
            </div>

            <div v-if="!isResultsPage" class="gamesm-item lb-sport game-border all game-all"
            :class="{'is-selected': (sportsselected[0] === 'all' && !onFavourites)}"
            v-on:click.stop="toggleAllSportsFilter()">
                <i class="sportsicon icon-all"></i>
            </div>

            <div class="gamesm-item lb-sport game-border"
            :class="[isMenuItemSelected(sport), 'sportbordercolor-'+sportMapping[sport.sportId]]"
            v-for="sport in sports"
            :key="sport.sportId"
            v-on:click.stop="selectSport([sport.sportId])">
                <i class="sportsicon lb-sport" :class="getSportIconClass(sport.sportId)"></i>
            </div>
        </div>
    </vue-scroll>
    <vue-scroll :settings="{wheelPropagation:true}" v-else class="offer-menu-box">
        <div class="offer-menu sport">
            <div class="offer-menu-item all" v-on:click.stop="showSearchBox" v-if="!isResultsPage">
                <i class="iconset icon-search menu-singleicon"></i>
                <div class="gamesm-text">{{$t('SEARCHEVENTS')}}</div>
            </div>
            <div class="offer-menu-item all" v-on:click="toggleGamesMenu" v-if="sportState == 'prematch' && pagetype != 'results'">
                <i class="iconset icon-calendar menu-singleicon"></i>
                <div class="gamesm-text">{{ $t('CALENDAR') }}</div>
            </div>

            <template
            v-if="globals
            && globals.publicConfig
            && globals.publicConfig.website
            && globals.publicConfig.website.displayPromoFilters">
                <div class="offer-menu-item offer-promo-mobile soccer">
                    <div class="gamesm-text">Liga prvaka</div>
                </div>
                <div class="offer-menu-item offer-promo-mobile basketball">
                    <div class="gamesm-text">FIBA Basketball 2022</div>
                </div>
            </template>

            <div class="offer-menu-item all" v-on:click="leaguesFilter = !leaguesFilter;">
                <i class="iconset icon-leagues menu-singleicon"></i>
                <div class="gamesm-text">{{ $t('LEAGUES') }}</div>
            </div>

            <div class="offer-menu-item all" @click.stop="toggleFavouriteSportFilter" v-if="showFavourites && !isResultsPage" :class="{'is-selected': onFavourites}">
                <i class="sportsicon lb-sport sporticon-favouritesactive"></i>
                <div class="gamesm-text">{{ $t('FAVOURITES') }}</div>
            </div>

            <div v-if="!isResultsPage" class="offer-menu-item all" v-on:click="toggleAllSportsFilter()" :class="(sportsselected[0] === 'all' && !onFavourites) ? 'is-selected' : ''">
                <i class="sportsicon icon-all"></i>
                <div class="gamesm-text">{{ $t('ALLSPORTS') }}</div>
            </div>
            <div class="offer-menu-item lb-sport"
            v-for="sport in sports"
            :key="sport.sportId"
            :class="[isMenuItemSelected(sport), 'sportbordercolor-'+sportMapping[sport.sportId]]"
            v-on:click.stop="selectSport([sport.sportId])">
                <i class="sportsicon lb-sport" :class="getSportIconClass(sport.sportId)"></i>
                <div class="gamesm-text">{{sport.sportName}}</div>
            </div>
        </div>
        <!-- search field -->
        <div class="offer-menu-search" v-if="searchBox" :class="{active:searchBox}">
            <div class="input-box">
                <div class="loading-container" v-if="searchLoading"><img src="../../../assets/img/loading.svg"></div>
                <input class="input-text" v-on:keyup.enter="startSearch" v-model="searchText" type="text" :placeholder="$t('SEARCHBYMATCHNAME')">
                <div class="offer-menu-search-btn" v-on:click.stop="startSearch"></div>
                <div class="gamesm-close-search-big" v-on:click.stop="clearSearch()" v-if="showSearchResults"></div>
            </div>
        </div>
        <!-- search results -->
        <div class="gamesm-search-box 3" v-if="showSearchResults">
            <div class="gamesm-search-container" v-if="showSearchResults && !searchError">
                   <div class="gamesm-search-item" v-for="sport in searchResults" :key="sport.sportId">
                        <template v-if="sport.outrights">
                            <div class="gamesm-searchi-header lb-sport sportbordercolor-outrights">{{sport.name}}</div>
                            <div class="gamesm-searchi-content" v-for="outright in sport.outrights" :key="outright.outrightId"
                                    v-on:click.prevent="selectOutright({
                                    outrightId: outright.outrightsOfferId,
                                    eventType: 'sport',
                                    push: null})" >
                                <p class="gamesm-searchi-teams">{{outright.name}}</p>
                                <p class="gamesm-searchi-tour">{{outright.tree[0].name}}</p>
                                <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(outright.endDate)}}</p>
                                <p v-else class="gamesm-searchi-date">{{outright.endDate | getLocalDate}}</p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="gamesm-searchi-header lb-sport" :class="'sportbordercolor-' + sportMapping[sport.sportId]">{{offertree.sports[sport.sportId].sportName}}</div>
                            <div class="gamesm-searchi-content" v-for="match in sport.matches" :key="match.matchId" v-on:click.prevent="selectSearchMatch(match.matchId)">
                                <p class="gamesm-searchi-teams">{{match.teamNameOne || 'not defined'}} - {{match.teamNameTwo || 'not defined'}}</p>
                                <p class="gamesm-searchi-tour">{{offertree.tournaments[match.tournamentId].tournamentName}}</p>
                                <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(match.matchDate)}}</p>
                                <p v-else class="gamesm-searchi-date">{{match.matchDate | getLocalDate}}</p>
                            </div>
                        </template>
                    </div>
            </div>
            <div class="gamesm-search-container" v-if="showSearchResults && searchError">
                <div class="gamesm-search-item no-results">{{ $t(searchError) }}</div>
            </div>
        </div>

        <!-- leagues filter -->
        <div class="games-menu fadeInDownMobileFilter" v-if="leaguesFilter" :class="{active:leaguesFilter}">
            <!-- sports item -->
            <div v-if="!isResultsPage && showFavourites" class="gamesm-item all-sports" v-on:click="toggleFavouriteSportFilter" :class="{'is-selected': onFavourites}">
                <div class="gamesm-item-content">
                    <div class="gamesm-content-left">
                        <i class="sportsicon lb-sport sporticon-favouritesactive"></i>
                        <div class="gamesm-text">{{$t('FAVOURITES')}} ({{favouritesOnCurrentOffer.length}})</div>
                    </div>
                </div>
            </div>
            <div v-if="!isResultsPage" class="gamesm-item all-sports" v-on:click="toggleAllSportsFilter()" :class="(sportsselected.length > 1) ? 'is-selected' : ''">
                <div class="gamesm-item-content">
                    <div class="gamesm-content-left">
                        <i class="sportsicon icon-all"></i>
                        <div class="gamesm-text">{{$t('ALLSPORTS')}}</div>
                    </div>
                </div>
            </div>
            <div class="gamesm-item" v-for="sport in sports" :key="sport.sportId" v-on:click.stop="selectSport([sport.sportId])" :class="(sportsselected[0] == sport.sportId) ? 'is-selected' : ''">
                <div class="gamesm-item-content lb-sport game-border" :class="'sportbordercolor-'+sportMapping[sport.sportId]">
                    <div class="gamesm-content-left">
                        <i class="sportsicon sportsicon lb-sport" :class="getSportIconClass(sport.sportId)"></i>
                        <div class="gamesm-text">{{sport.sportName}} ({{sport.matchesNum}})</div>
                    </div>
                    <div class="gamesm-content-right" v-on:click.stop="toggleSport(sport.sportId)">
                        <span class="gamesm-arrow" :class="(sportsShown.indexOf(sport.sportId) !== -1) ? 'is-selected' : ''"></span>
                    </div>
                </div>
                <template v-if="sportsShown.indexOf(sport.sportId) !== -1">
                    <div class="gamesm-category-box fadeInDownMobileFilter" v-for="category in sport.categories" :key="category.categoryId" :class="(categoryselected[0] == category.categoryId) ? 'is-selected' : ''" v-on:click.stop="selectCategory(sport, category)">
                        <div class="gamesm-category-content">
                            <div class="gamesm-text small">{{category.categoryName}} ({{category.matchesNum}})</div>
                            <span class="gamesm-arrow"
                            :class="(categoriesShown.indexOf(category.categoryId) !== -1) ? 'is-selected' : ''"
                            v-on:click.stop="toggleCategory(category.categoryId)"
                            v-if="category.hasTournamentFilter === undefined
                            || category.hasTournamentFilter === true"></span>
                        </div>
                        <template v-if="categoriesShown.indexOf(category.categoryId) !== -1">
                            <div class="gamesm-tour-box fadeInDownMobileFilter" v-for="tournament in category.tournaments" :key="tournament.tournamentId" :class="(tournamentselected[0] == tournament.tournamentId) ? 'is-selected' : ''" v-on:click.stop="selectTournament(sport, category, tournament)">
                                <div class="gamesm-tour-content">
                                    <div class="gamesm-text small">{{tournament.tournamentName}} ({{tournament.matchesNum}})</div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';

import moment from 'moment-timezone';
import { Common } from '@om-retail/vue-common';

export default
{
    name: 'GamesMenu',
    props: ['sports', 'sportsselected', 'categoryselected', 'tournamentselected',
        'offertree', 'matchesIn', 'pagetype', 'outrightsIn'],
    data()
    {
        return {
            expandedMenu: true,
            searchBox: false,
            searchText: '',
            searchError: false,
            searchResults: {},
            showSearchResults: false,
            searchLoading: false,
            leaguesFilter: false,
            sportsShown: [],
            categoriesShown: [],
            tournamentsShown: [],
        };
    },
    created()
    {
        const me = this;

        if (me.$route.params.sportId !== undefined)
        {
            const { sportId } = me.$route.params;

            if (sportId !== undefined)
            {
                if (sportId === 'bonus')
                {
                    me.toggleSport(sportId);
                }
                else
                {
                    me.toggleSport(parseInt(sportId, 10));
                }
            }
        }
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'startDate',
            'offerHandling',
            'sportState',
            'globalEventBlock',
        ]),
        ...mapGetters('favourites', [
            'showFavouritesOnMenu',
            'hasLiveFavourites',
            'hasPrematchFavourites',
            'favouritesOnCurrentOffer',
        ]),
        showFavourites()
        {
            return ((this.hasLiveFavourites && this.$route.name === 'live')
            || (this.hasPrematchFavourites && this.$route.name === 'prematch'))
            && this.showFavouritesOnMenu;
        },
        sportMapping()
        {
            const me = this;
            let val = {};

            if (me.globals
            && me.globals.props
            && me.globals.props.sportMapping)
            {
                val = me.globals.props.sportMapping;
            }

            return val;
        },
        isResultsPage()
        {
            const me = this;

            return (me.$route.path.indexOf('results') !== -1);
        },
        onFavourites()
        {
            return this.$route.params.mode === 'favourites';
        },
    },
    methods:
    {
        ...mapActions({
            selectMatchInit: 'selectMatch',
            selectSearchMatch: 'selectSearchMatch',
            selectOutright: 'selectOutright',
        }),
        getSportIconClass(sportId)
        {
            const me = this;

            let sportIconName = 'noicon';

            if (me.sportMapping[sportId] !== undefined)
            {
                sportIconName = me.sportMapping[sportId];
            }

            return `sporticon-${sportIconName}`;
        },
        selectMatch(matchId)
        {
            const me = this;

            me.selectMatchInit({
                id: matchId,
                type: 'sport',
            });
        },
        toggleGamesMenu()
        {
            const me = this;

            me.$emit('togglegamesmenu');
        },
        async startSearch()
        {
            const me = this;

            me.leaguesFilter = false;

            me.searchResults = {};

            const searchResultsOut = {};

            me.searchLoading = true;

            if (me.searchText.length >= 3)
            {
                me.searchError = false;

                const dateNow = moment().utc().format('YYYY-MM-DD HH:mm:ss');

                let params = {};

                if (me.pagetype !== 'results')
                {
                    params = {
                        status: 'active,block',
                        minoffer: '1',
                        search: me.searchText,
                        startDate: dateNow,
                        endDate: moment(dateNow).add(365, 'd').format('YYYY-MM-DD HH:mm:ss'),
                        state: me.sportState,
                    };
                    if (me.sportState === 'live')
                    {
                        params.startDate = moment(dateNow).subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss');
                        params.endDate = dateNow;
                    }
                }
                else
                {
                    params = {
                        status: 'finished',
                        minoffer: '1',
                        search: me.searchText,
                        startDate: moment(dateNow).subtract(30, 'd').format('YYYY-MM-DD HH:mm:ss'),
                        endDate: dateNow,
                        results: '1',
                    };
                }

                const data = await me.offerHandling.callOffer(`/${me.globals.langCode}/sport/getOffer`, params);

                const matches = data.data;
                const outrights = [];

                if (me.globals
                && me.globals.publicConfig
                && me.globals.publicConfig.verticalsAvailable
                && me.globals.publicConfig.verticalsAvailable.outrights)
                {
                    const data2 = await me.offerHandling.callOffer(`/${me.globals.langCode}/outrights/getOutrightsOffer`, params);

                    for (const outright of data2.data)
                    {
                        for (const treeItem of outright.tree)
                        {
                            if (treeItem.connectionType != null)
                            {
                                outrights.push(outright);
                            }
                        }
                    }
                }

                const allData = [...outrights, ...matches];

                if (allData.length)
                {
                    if (outrights.length)
                    {
                        for (let i = 0; i < outrights.length; i += 1)
                        {
                            const outright = outrights[i];

                            const { name } = outright.tree[outright.tree.length - 1];

                            if (searchResultsOut[outright.outrightsOfferId] === undefined
                            && !searchResultsOut[name])
                            {
                                searchResultsOut[name] = {
                                    name,
                                    outrights: [],
                                    sportId: outright.outrightsOfferId,
                                };
                            }

                            searchResultsOut[name].outrights.push(outright);
                        }
                    }

                    if (matches.length)
                    {
                        for (let i = 0; i < matches.length; i += 1)
                        {
                            const match = matches[i];

                            if (searchResultsOut[match.sportId] === undefined)
                            {
                                searchResultsOut[match.sportId] = {
                                    matches: [],
                                    sportId: match.sportId,
                                };
                            }

                            searchResultsOut[match.sportId].matches.push(match);
                        }
                    }

                    me.searchError = false;
                }
                else
                {
                    me.searchError = 'NORESULTSFOUND';
                }
            }
            else
            {
                me.searchError = 'SEARCHTERMTOOSHORT';
            }

            me.showSearchResults = true;
            me.searchResults = searchResultsOut;
            me.searchLoading = false;
            me.searchBox = true;
        },
        clearSearch()
        {
            const me = this;

            me.searchBox = false;
            me.searchError = false;
            me.showSearchResults = false;
            me.searchResults = {};
            me.searchText = '';
            me.searchError = false;
        },
        showSearchBox()
        {
            const me = this;
            me.searchBox = !me.searchBox;
            me.searchText = '';

            if (!me.searchBox)
            {
                me.showSearchResults = false;
            }

            me.$nextTick(() =>
            {
                if (me.$refs.searchBoxInput)
                {
                    me.$refs.searchBoxInput.focus();
                }
            });
        },
        toggleAllSportsFilter()
        {
            const me = this;

            const sportIds = [
                'all',
            ];
            /* for (const sport of me.sports)
            {
                sportIds.push(sport.sportId);
            } */

            me.selectSport(sportIds);
        },
        toggleFavouriteSportFilter()
        {
            this.$emit('selectFavourites');
        },
        selectSport(val)
        {
            const me = this;
            me.leaguesFilter = false;

            me.$emit('selectsport', val);
        },
        selectCategory(sport, category)
        {
            const me = this;
            me.leaguesFilter = false;

            const params = {
                sportId: sport.sportId,
                categoryId: category.categoryId,
            };

            me.$emit('selectcategory', params);
        },
        selectTournament(sport, category, tournament)
        {
            const me = this;
            me.leaguesFilter = false;

            const params = {
                sportId: sport.sportId,
                categoryId: category.categoryId,
                tournamentId: tournament.tournamentId,
            };

            me.$emit('selecttournament', params);
        },
        toggleSport(sport)
        {
            const me = this;
            const index = me.sportsShown.indexOf(sport);

            if (index !== -1)
            {
                me.sportsShown.splice(index, 1);
            }
            else
            {
                me.sportsShown.push(sport);
            }
        },
        toggleCategory(category)
        {
            const me = this;
            const index = me.categoriesShown.indexOf(category);

            if (index !== -1)
            {
                me.categoriesShown.splice(index, 1);
            }
            else
            {
                me.categoriesShown.push(category);
            }
        },
        isMenuItemSelected(sport)
        {
            const me = this;
            return (me.sportsselected[0] === sport.sportId) ? 'is-selected' : '';
        },
        getLastPeriod(periods, teamNum)
        {
            if (periods.length === 0)
            {
                return '';
            }
            return periods[periods.length - 1][`t${teamNum}Scr`];
        },
        getLiveMinutes(match)
        {
            const me = this;

            let val = Common.formatLiveEventDetails(match);

            if (!val.length
            && (me.matchesIn[match.matchId].metaData.status !== 'NOT_STARTED'
            || (me.matchesIn[match.matchId].metaData.min !== undefined
            && me.matchesIn[match.matchId].metaData.periodStatus !== null)))
            {
                val = me.$t(`WEB_${me.matchesIn[match.matchId].metaData.periodStatus}`);
            }

            return val;
        },
    },
    watch:
    {
        expandedMenu()
        {
            const me = this;
            me.showSearchResults = false;
            me.searchBox = false;
        },
        leaguesFilter(val)
        {
            const me = this;

            if (val)
            {
                me.clearSearch();
            }
        },
        searchBox(val)
        {
            const me = this;

            if (val)
            {
                me.leaguesFilter = false;
            }
        },
        startDate(val)
        {
            const me = this;

            if (val !== false)
            {
                me.leaguesFilter = false;
            }
        },
    },
};
</script>
